import { useQuery } from '@apollo/client';
import { IInsuranceProviderResponse } from '@folx-types/insurance';
import INSURANCE_PROVIDERS from '@graphql/queries/insuranceProviders.query.gql';
import { useMemo } from 'react';

const useInsuranceProviders = () => {
	const { loading, data, error } = useQuery<IInsuranceProviderResponse>(INSURANCE_PROVIDERS);

	const sortedData = useMemo(() => {
		if (data?.insuranceProviders?.nodes) {
			const providers = data.insuranceProviders.nodes;
			const other = providers.filter((provider) => provider.name === 'Other')?.[0];
			return [...providers.filter((provider) => provider.name !== 'Other'), other];
		}
	}, [data?.insuranceProviders?.nodes]);

	return { loading, error, data: sortedData };
};

export default useInsuranceProviders;
